<!-- <input type="text" class="form-control input-lg" [(ngModel)]="searchTerm" (ngModelChange)="searchOnRows()" placeholder="Search" /> -->

<!-- <input type="text" class="form-control input-lg" [(ngModel)]="searchTerm" (ngModelChange)="searchOnRows()" placeholder="Search" /> -->

<div id="fn-search-input" class="input-group table-search" [class]="tblSearchClass">
    <input type="text" class="form-control" id="fn-table-serch-i" (input)="debounce($event.target.value)"
           placeholder="Type to search" fnAutoFocus />
    <div class="input-group-append">
        <button class="btn btn-outline-secondary btn-sm" type="button">
            <i [class]="inputSrchClass" (click)="handleClose($event)"></i>
        </button>
    </div>
</div>
